import request from '@/lib/request.mjs';

export default function (temporaryRedirectUuid, clientUuid) {
  return request('deleteTemporaryRedirect', {
    client_uuid: clientUuid,
    temporary_redirect_uuid: temporaryRedirectUuid,
  });
}
